import { useEffect, useMemo, useState } from 'react';

function firstCharacter(value) {
  const text = String(value || '').trim();
  return text ? [...text][0] : '?';
}

export function BlablaLinkProfileAvatar({
  nickname,
  avatarUrl = '',
  className = '',
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const fallback = useMemo(() => firstCharacter(nickname), [nickname]);

  useEffect(() => setImageFailed(false), [avatarUrl]);

  const showImage = Boolean(avatarUrl) && !imageFailed;

  return (
    <span className={`my-info-avatar ${showImage ? 'has-image' : 'fallback'} ${className}`.trim()} aria-hidden="true">
      {showImage ? (
        <img
          className="my-info-avatar-image"
          src={avatarUrl}
          alt=""
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setImageFailed(true)}
        />
      ) : <span className="my-info-avatar-fallback">{fallback}</span>}
    </span>
  );
}
